export default __webpack_public_path__ + "static/media/portfolio-midios-3.d4fa0706.png";